import {
  Dispatch,
  SetStateAction,
  useCallback,
  useEffect,
  useState,
} from 'react';

/**
 * @deprecated Use zustand instead
 */
export function usePersistedState<T>(
  key: string,
  initialState: T,
  store = window.sessionStorage,
): [T, Dispatch<SetStateAction<T>>] {
  const [items, setItems] = useState(() =>
    defaultState(key, initialState, store),
  );

  useEffect(
    () => store.setItem(key, JSON.stringify(items)),
    [items, store, key],
  );

  const saveAndSetItems = useCallback(
    (next: SetStateAction<T>) =>
      setItems((old) => ({
        data: next instanceof Function ? next(old.data) : next,
      })),
    [setItems],
  );

  return [items.data, saveAndSetItems];
}

const defaultState = <T>(key: string, initialState: T, store: Storage) => {
  const def = { data: initialState };
  const raw = store.getItem(key);

  if (raw === null) {
    // there is no item with this key in the state
    return def;
  }

  try {
    return JSON.parse(raw) as { data: T };
  } catch {
    return def;
  }
};
